import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import CardView from "../../../components/common/CardView";
import AllowanceTypePresenter from "./AllowanceTypePresenter";
import Progress from "../../../components/Progress";

class AllowanceTypePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AllowanceTypePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "allowance_type";
  }

  handleViewData(data) {
    this.navigateTo(`/form/${this.getCollectionName()}/${data.id}`);
  }

  async handleDeleteData(id) {
    const filterAllowancePromise = this.presenter.findObjectUseCase.execute(
      "allowance_type",
      { where: { id: id } }
    );

    const allowancesPromise =
      this.presenter.findObjectUseCase.execute("allowances");

    const [filterAllowance, allowances] = await Promise.all([
      filterAllowancePromise,
      allowancesPromise,
    ]);
    const relatedAllowances = allowances.filter(
      (item) => item.allowance === filterAllowance[0]?.AllowanceType
    );

    const deletePromises = relatedAllowances.map((item) =>
      this.presenter.deleteObjectUseCase.execute("allowances", item.id)
    );

    await Promise.all(deletePromises);
    await this.presenter.deleteObjectUseCase.execute("allowance_type", id);
    dialog.close();
    this.refetchData();
  }

  deleteConfirmation(data) {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Delete Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Are you sure you want to delete?
            </p>
            <hr />
          </div>
          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={() => dialog.close()}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => {
                this.handleDeleteData(data.id);
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  createAllowances() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Reference Table {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        // onClick={this.handleAddRegion.bind(this)}
                        onClick={this.createAllowances.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewObject={this.handleViewData.bind(this)}
                objectId={this.deleteConfirmation.bind(this)}
                editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(AllowanceTypePage);
